import React from 'react'
import { Alert,AlertIcon,Container } from '@chakra-ui/react'
function Error() {
  return (
    <Alert status='error' position={"fixed"} bottom={"4"} left={"50%"} transform={"translateX(-50%)"} w={'container.lg'}>
      <Container display={"flex"} justifyContent={"center"}>
<AlertIcon/>
Error While Fetching Exchanges
</Container>
  </Alert>
  )
}
export default Error
